// Mock data for Kanama Naturals — replaced with real backend later

export const PRODUCTS = [
  {
    id: "chebe-powder",
    slug: "chebe-powder",
    name: "Chebe Powder from Chad",
    tagline: "Authentic Natural Hair Strengthening & Moisture Treatment",
    price: 11.99,
    compareAt: 15.99,
    category: "Hair",
    badge: "Bestseller",
    inStock: true,
    rating: 4.9,
    reviews: 214,
    image: "https://static.wixstatic.com/media/c4cb0e_296a0777082a4a7fb43f25e8d23d803a~mv2.jpeg",
    gallery: [
      "https://static.wixstatic.com/media/c4cb0e_296a0777082a4a7fb43f25e8d23d803a~mv2.jpeg"
    ],
    description:
      "Sourced directly from the women of Chad, our signature Chebe Powder is an ancestral blend that locks in moisture and dramatically reduces breakage. A ritual passed down for generations, now refined for the modern hair care routine.",
    benefits: [
      "Reduces breakage and split ends",
      "Seals in deep, lasting moisture",
      "Encourages length retention",
      "100% natural, ethically sourced"
    ],
    ingredients:
      "Croton Zambesicus (Chebe), Lavender, Cherry Kernels, Resin Tree Sap, Fragrant Grasses.",
    howToUse:
      "Mist hair with water or leave-in. Apply a natural oil or butter, then work Chebe Powder through the mid-lengths and ends. Braid or twist and leave in. Repeat 2–3 times weekly."
  },
  {
    id: "raw-shea-butter",
    slug: "raw-shea-butter",
    name: "Pure African Shea Butter",
    tagline: "Raw Organic, Unrefined from Chad",
    price: 15.99,
    compareAt: 19.99,
    category: "Body",
    badge: "Organic",
    inStock: true,
    rating: 4.8,
    reviews: 176,
    image: "https://static.wixstatic.com/media/c4cb0e_c14faef4cffa49b6afcb938038c3f0d5~mv2.png",
    gallery: [
      "https://static.wixstatic.com/media/c4cb0e_c14faef4cffa49b6afcb938038c3f0d5~mv2.png"
    ],
    description:
      "Hand-whipped, unrefined and pure. Our raw shea butter is rich in vitamins A and E, melting into the skin to restore softness and a healthy glow from head to toe.",
    benefits: [
      "Deeply nourishes dry skin",
      "Rich in vitamins A & E",
      "Soothes and softens",
      "Unrefined and additive-free"
    ],
    ingredients: "100% Unrefined Raw Shea Butter (Vitellaria Paradoxa).",
    howToUse:
      "Warm a small amount between palms until it melts. Massage into skin, hair, or beard. Use daily for best results."
  },
  {
    id: "chebe-hair-beard-oil",
    slug: "chebe-hair-beard-oil",
    name: "Chebe Hair & Beard Oil",
    tagline: "Lightweight Daily Nourishing Oil",
    price: 11.99,
    compareAt: null,
    category: "Beard",
    badge: null,
    inStock: false,
    rating: 4.7,
    reviews: 98,
    image: "https://static.wixstatic.com/media/c4cb0e_f8faeccc8aac4c9c81663a1ce97928b3~mv2.jpg",
    gallery: [
      "https://static.wixstatic.com/media/c4cb0e_f8faeccc8aac4c9c81663a1ce97928b3~mv2.jpg"
    ],
    description:
      "A featherlight blend infused with chebe and botanical oils. Absorbs quickly to condition hair and beard, leaving a soft sheen without any grease.",
    benefits: [
      "Tames frizz and flyaways",
      "Softens coarse beard hair",
      "Non-greasy, fast absorbing",
      "Subtle natural scent"
    ],
    ingredients:
      "Chebe Infusion, Jojoba Oil, Castor Oil, Argan Oil, Vitamin E.",
    howToUse:
      "Dispense 3–5 drops into palms and massage through damp or dry hair and beard. Style as usual."
  },
  {
    id: "organic-chebe-butter",
    slug: "organic-chebe-butter",
    name: "Organic Chebe Butter",
    tagline: "For Hair & Beard — Deep Conditioning",
    price: 18.99,
    compareAt: 24.99,
    category: "Hair",
    badge: "Premium",
    inStock: true,
    rating: 4.9,
    reviews: 143,
    image: "https://static.wixstatic.com/media/c4cb0e_7d289b6b3c0b4455bf74d240a21c8b90~mv2.jpeg",
    gallery: [
      "https://static.wixstatic.com/media/c4cb0e_7d289b6b3c0b4455bf74d240a21c8b90~mv2.jpeg"
    ],
    description:
      "Our richest treatment. Chebe powder whipped into shea and cocoa butters for an intense conditioning mask that strengthens and defines coils and beards alike.",
    benefits: [
      "Intense deep conditioning",
      "Defines curls and coils",
      "Strengthens strands",
      "Long-lasting moisture seal"
    ],
    ingredients:
      "Shea Butter, Cocoa Butter, Chebe Powder, Coconut Oil, Fragrant Grasses.",
    howToUse:
      "Apply generously to damp hair or beard. Leave as a mask for 20 minutes or use as a daily leave-in sealant."
  },
  {
    id: "coconut-shampoo",
    slug: "coconut-shampoo",
    name: "Coconut Oil Shampoo",
    tagline: "Gentle Sulfate-Free Cleanser",
    price: 12.99,
    compareAt: null,
    category: "Hair",
    badge: null,
    inStock: false,
    rating: 4.6,
    reviews: 87,
    image: "https://static.wixstatic.com/media/c4cb0e_6dab03514743426b9dbab112ce802556~mv2.jpg",
    gallery: [
      "https://static.wixstatic.com/media/c4cb0e_6dab03514743426b9dbab112ce802556~mv2.jpg"
    ],
    description:
      "A sulfate-free cleanser powered by coconut oil that gently removes buildup while preserving your hair's natural moisture balance.",
    benefits: [
      "Sulfate & paraben free",
      "Cleanses without stripping",
      "Adds softness and shine",
      "Safe for color-treated hair"
    ],
    ingredients: "Coconut-derived surfactants, Aloe Vera, Glycerin, Coconut Oil.",
    howToUse: "Massage into wet hair, lather, and rinse thoroughly. Follow with conditioner."
  },
  {
    id: "coconut-conditioner",
    slug: "coconut-conditioner",
    name: "Coconut Oil Conditioner",
    tagline: "Hydrating Detangling Conditioner",
    price: 12.99,
    compareAt: null,
    category: "Hair",
    badge: null,
    inStock: false,
    rating: 4.7,
    reviews: 76,
    image: "https://static.wixstatic.com/media/c4cb0e_5e30bf1b42974ee8bd0063d6c7438595~mv2.jpg",
    gallery: [
      "https://static.wixstatic.com/media/c4cb0e_5e30bf1b42974ee8bd0063d6c7438595~mv2.jpg"
    ],
    description:
      "A creamy, hydrating conditioner that melts through tangles and drenches strands in coconut-rich moisture for effortless slip.",
    benefits: [
      "Effortless detangling",
      "Deep hydration",
      "Reduces frizz",
      "Lightweight finish"
    ],
    ingredients: "Coconut Oil, Shea Butter, Behentrimonium, Aloe Vera, Vitamin E.",
    howToUse: "After shampooing, apply from mid-length to ends. Leave 2–3 minutes and rinse."
  },
  {
    id: "braiding-gel",
    slug: "braiding-gel",
    name: "Braiding Gel — Extreme Hold",
    tagline: "Flake-Free Long-Lasting Hold",
    price: 17.99,
    compareAt: null,
    category: "Grooming",
    badge: null,
    inStock: false,
    rating: 4.8,
    reviews: 112,
    image: "https://static.wixstatic.com/media/c4cb0e_79eccb401b964ebc982eb234ad384ddc~mv2.jpg",
    gallery: [
      "https://static.wixstatic.com/media/c4cb0e_79eccb401b964ebc982eb234ad384ddc~mv2.jpg"
    ],
    description:
      "Extreme, flake-free hold for sleek braids, edges and protective styles that last for days without buildup or crunch.",
    benefits: [
      "All-day extreme hold",
      "No white flakes",
      "Enriched with castor oil",
      "Sleek, polished finish"
    ],
    ingredients: "Castor Oil, Aloe Vera, Flaxseed Extract, Glycerin.",
    howToUse: "Apply to clean, damp hair. Smooth, braid or lay edges and allow to set."
  }
];

export const CATEGORIES = ["All", "Hair", "Body", "Beard", "Grooming"];

export const TESTIMONIALS = [
  {
    name: "Amara O.",
    location: "Atlanta, GA",
    text: "The Chebe Powder transformed my length retention. My coils have never felt this strong and moisturized. A true ritual.",
    rating: 5
  },
  {
    name: "Marcus T.",
    location: "Houston, TX",
    text: "The Chebe Butter is the only thing that keeps my beard soft and full. Luxury quality, honest ingredients.",
    rating: 5
  },
  {
    name: "Nadia B.",
    location: "London, UK",
    text: "You can feel the tradition in every jar. The raw shea butter melts like silk. Kanama is now a staple in my home.",
    rating: 5
  }
];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1527203561188-dae1bc1a417f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxibGFjayUyMHdvbWFuJTIwYmVhdXR5fGVufDB8fHx8MTc4ODU1ODg4Nnww&ixlib=rb-4.1.0&q=85";

export const ABOUT_IMAGE =
  "https://images.unsplash.com/photo-1632765866070-3fadf25d3d5b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwzfHxhZnJvJTIwaGFpcnxlbnwwfHx8fDE3ODg1NTg4OTN8MA&ixlib=rb-4.1.0&q=85";

export const EDITORIAL_IMAGE =
  "https://images.unsplash.com/photo-1613876215075-276fd62c89a4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHw0fHxibGFjayUyMHdvbWFuJTIwYmVhdXR5fGVufDB8fHx8MTc4ODU1ODg4Nnww&ixlib=rb-4.1.0&q=85";

export const BEARD_IMAGE =
  "https://images.unsplash.com/photo-1691889713819-6c394041a2fa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHw0fHxibGFjayUyMHNraW4lMjBjYXJlfGVufDB8fHx8MTc4ODU1ODg5M3ww&ixlib=rb-4.1.0&q=85";
